import { useEffect } from 'react';
import { useIsAuthenticated } from '@azure/msal-react';
import { useDispatch, useSelector } from 'react-redux';

import { authActions } from '../redux/auth/actions';
import { getUser, getLoadingStatus } from '../redux/auth/selectors';

export const useAuthData = () => {
  const isAuthenticated = useIsAuthenticated();
  const dispatch = useDispatch();
  const user = useSelector(getUser);
  const loading = useSelector(getLoadingStatus);

  useEffect(() => {
    if (!isAuthenticated) return;

    dispatch(authActions.whoAmI());
  }, [dispatch, isAuthenticated]);

  return { user, loading };
};
